import {
  customParse,
  fetchCurrentSalesOrder,
  formatCurrAmount,
  formatDigits,
  getDecryptID,
  isEmptyObject,
  parseFloatCustom,
  parseIntCustom
} from '../actions'
import {
  PRINT_CASH_MOVE_TYPES,
  PRINT_CONST_FOOTER_1,
  PRINT_CONST_FOOTER_2,
  // REACT_APP_PRINT_CONST_FOOTER_3,
  PRINT_TYPES
} from '../../constants/StoreSetting'
import moment from 'moment'
import { env } from '../../env'

const { REACT_APP_PRINT_CONST_FOOTER_3 } = env

export const getSalesFormattedPrint = (
  templateData,
  data,
  today,
  currencyCode,
  decimal,
  allowPrintNote,
  allowDiscountShow
) => {
  var printString = ''
  let sellAttribs = ''
  data.sellSelData &&
    data.sellSelData.length > 0 &&
    data.sellSelData.map((as, io) => {
      sellAttribs += `${
        as.groupName || as.attributeName
          ? `[C]${as.groupName} ${as.attributeName ? as.attributeName : ''}`
          : ''
      }\n`
      // return `${as.groupName || as.attributeName ? `[C]${as.groupName} ${as.attributeName ? as.attributeName : ''}`: ''}\n`
    })
  let prods = ''
  data.products &&
    data.products.length > 0 &&
    data.products.map((e, key) => {
      let discApply = false
      if (templateData.showSKU) {
        prods += `[L]<b>${e.SKU ? `SKU: ${e.SKU} ` : ''}</b>`
      }
      if (templateData.showProductName) {
        prods += `[L]<b>${e.productName ? `${e.productName}` : ''}</b>`
      }
      if (templateData.showProductNameAndSKU) {
        prods += `[L]<b>${e.productName ? `${e.productName} / ` : ''}${
          e.SKU ? `SKU: ${e.SKU} ` : ''
        }</b>`
      }

      if (templateData.showProdPrice) {
        prods += `${e.quantity ? ` (${parseIntCustom(e.quantity)})` : ''}`
        prods += ' x '
      } else {
        prods += `[R]<b>${
          e.quantity ? `${parseIntCustom(e.quantity)}` : ''
        }</b>\n`
      }

      if (templateData.showProdPrice && e.totalPriceReceipt) {
        prods += `${currencyCode} ${formatDigits(
          parseFloatCustom(e.totalPriceReceipt) / parseFloatCustom(e.quantity),
          decimal
        )}`
      }

      if (templateData.showProdPrice && e.totalPriceReceipt) {
        prods += `[R]<b>${currencyCode} ${e.totalPriceReceipt}</b>${
          e.taxCode ? e.taxCode : ''
        }\n`
      }

      if (templateData.showProdPrice && allowDiscountShow) {
        if (e.salesItemDiscount && customParse(e.salesItemDiscount) > 0) {
          prods += `[L]Was: ${currencyCode} ${formatDigits(
            customParse(e.totalPriceReceipt / e.quantity) +
              customParse(e.salesItemDiscount),
            decimal
          )}\n`
          prods += `[L]Disc: ${
            e.discountPercentage
          }% / ${currencyCode} ${formatDigits(e.salesItemDiscount, decimal)}\n`
          // prods += `[R]<b>${currencyCode} ${formatDigits(customParse(e.totalPriceReceipt) + customParse(e.salesItemDiscount * e.quantity), decimal)}</b>\n`
          discApply = true
        }

        if (
          e.promotions &&
          !isEmptyObject(e.promotions) &&
          e.promotions.promotionName &&
          e.promotions.promotionName != ''
        ) {
          prods += `[L]Promotion: ${e.promotions.promotionName} (${
            e.promotionPercent ? `${e.promotionPercent}% / ` : ''
          }`
          prods += `${currencyCode} ${
            e.promotions.promotionValue
              ? formatDigits(e.promotions.promotionValue / e.quantity, decimal)
              : '0.00'
          } off)\n`
          // if(e.promotion && e.promotion.promoCodes && e.promotion.promoCodes.length > 0){
          //   prods += ``
          // }
          discApply = true
        }

        if (e.priceBookValue && customParse(e.priceBookValue) > 0) {
          prods += `[L]Disc: (${
            e.priceBookPercent ? `${e.priceBookPercent}%  / ` : ''
          } ${currencyCode} `
          prods += `${formatDigits(
            e.priceBookValue / e.quantity,
            decimal
          )} off)\n`
          discApply = true
        }
      }

      if (allowPrintNote && e.productNote && e.productNote != '') {
        prods += `[L]ITEM NOTE: ${e.productNote}\n`
      }

      if (discApply) {
        //  || data.products.length != (key + 1)
        prods += `\n`
      }
      // return prods
    })

  // if (templateData.headImageURL) {
  //   printString += `[L][C]<img>${templateData.headImageURL}</img>\n`
  // }
  if (
    templateData.headInfoHtml &&
    !templateData.headInfoHtml.includes('null')
  ) {
    printString += `${templateData.headInfoHtml}\n`
  }
  if (templateData.showOutlet && data.outletName) {
    printString += `[C]<b>${data.outletName}</b>\n`
  }
  if (templateData.showRegister && data.mainRegister) {
    printString += `[C]<b>${data.mainRegister}</b>\n`
  }
  if (templateData.isDisplayServedBy && data.soldBy) {
    printString += `[C]Served By: <b>${data.soldBy}</b>\n`
  }
  if (data.isRepeat) {
    printString += `[C]* * *Reprint* * *\n`
  }

  if (data.receipt) {
    printString += `[C]<u><b>${
      templateData.invoiceNoPrefix
        ? `${templateData.invoiceNoPrefix} `
        : 'Receipt '
    }${data.receipt}</b></u>\n`
  }
  if (templateData.showDatetime) {
    printString += `[C]${today}\n`
  }
  if (data.saleNature && data.saleNature != '') {
    printString += `[C]${data.saleNature}\n`
  }
  if (data.isRefundSale) {
    printString += `[C]RETURN SALE\n`
  }
  if (sellAttribs) {
    printString += sellAttribs
  }

  printString += `[C]---------------------------------\n`

  if (prods) {
    printString += prods
  }

  if (allowPrintNote && data && data.Notes) {
    printString += `[C]---------------------------------\n`
    printString += `[L]SALE NOTE: ${data.Notes}\n`
  }

  if (templateData.showSubTotal && data.totalPrice) {
    printString += `[C]-------------------------------\n`
    printString += `[L]${
      templateData.subTotalLabel ? templateData.subTotalLabel : 'SUBTOTAL'
    }`
    printString += `[R]<b>${currencyCode}`
    printString += `${formatDigits(
      customParse(data.totalPrice) +
        (data.additionalDiscount && data.additionalDiscount != '0.00'
          ? customParse(data.additionalDiscount)
          : 0) -
        customParse(data.totalTax),
      decimal
    )}</b>\n`
  }

  if (
    (templateData.showTotal || templateData.showSubTotal) &&
    data.additionalDiscount &&
    data.additionalDiscount != ''
  ) {
    printString += `[L]Additional Discount[R]<b>${currencyCode} `
    printString += `${
      data.additionalDiscount && data.additionalDiscount.includes('-')
        ? data.additionalDiscount.replace('-', '')
        : data.additionalDiscount
    }</b>\n`
  }

  if (templateData.showTaxTotals && data.totalTax) {
    printString += `\n[L]${
      templateData.taxTotalLabel ? templateData.taxTotalLabel : 'TOTAL TAX'
    }`
    printString += `${
      data && data.taxesSum && data.taxesSum.length > 0
        ? ` (${data.taxesSum.length} Taxes)`
        : ''
    }`

    printString += `[R]<b>${currencyCode} ${data.totalTax}</b>\n`
  }

  if (templateData.showTaxTotals && data.taxesSum && data.taxesSum.length > 0) {
    let sums = ''
    const taxesSum = data.taxesSum.map((e, key) => {
      sums += `[L]${
        e.saleTaxName
          ? `${e.saleTaxName} ${e.taxCode ? e.taxCode : ''}   (${
              e.isFix ? e.fixRate : e.taxValue
            } ${e.isFix ? ' FIX' : '%'})`
          : ''
      }`

      if (
        (getDecryptID(data.sSalesOrderStatusID) ==
          getDecryptID(fetchCurrentSalesOrder('On Account, completed')) ||
          getDecryptID(data.sSalesOrderStatusID) ==
            getDecryptID(fetchCurrentSalesOrder('Layby, completed'))) &&
        data.salesOrderDiscountPrice &&
        data.salesOrderDiscountPrice != '0.00'
      ) {
      } else {
        if (
          data.isRefundSale &&
          data.additionalDiscount &&
          data.additionalDiscount != ''
        ) {
        } else {
          sums += `[R]${e.taxPrice ? `${currencyCode} ${e.taxPrice}` : ''}`
        }
      }

      sums += '\n'
      // if(data.taxesSum.length == (key + 1)){
      //   sums += '\n'
      // }
      // return sums
    })

    if (sums) {
      // taxesSum && !isEmptyObject(taxesSum)
      printString += sums // taxesSum
    }
  }

  if (templateData.showTotal && data.totalPrice) {
    printString += `[C]---------------------------------\n`
    printString += `[L]${
      templateData.totalLabel ? templateData.totalLabel : 'TOTAL'
    }`
    printString += `[R]<b>${currencyCode} ${data.totalPrice}</b>\n`
  }

  if (templateData.showPayments && data.payments && data.payments.length > 0) {
    printString += `[C]---------------------------------\n`
    printString += `[L]<b>Payments Through:</b>`
    let pays = ''
    const payString = data.payments.map((pay, key) => {
      if (pay.amount != '0.00') {
        pays += `\n[L]${
          pay.paymentName ? pay.paymentName : `Payment ${key + 1}`
        }`
        pays += pay.paymentOn ? `   (${pay.paymentOn})` : ''
        pays += pay.amount ? `[R]${currencyCode} ${pay.amount}` : ''

        if (data.payments.length == key + 1) {
          pays += '\n'
        }
      }
      // return pays
    })

    printString += pays // payString
  }

  if (templateData.showPayments && data.toPay && data.toPay != '') {
    printString += `[C]---------------------------------\n`
    printString += `[L]${
      templateData.toPayLabel ? templateData.toPayLabel : 'TO PAY'
    }`
    printString += `[R]${currencyCode} ${data.toPay}\n`
  }

  if (
    templateData.showLoyaltyEarned &&
    data.totalLoyaltyValue &&
    data.totalLoyaltyValue > 0
  ) {
    printString += `[L]${
      templateData.loyaltyEarnedLabel
        ? templateData.loyaltyEarnedLabel
        : 'Loyalty Earned'
    }`
    printString += `[R]${currencyCode} ${formatDigits(
      data.totalLoyaltyValue,
      decimal
    )}\n`
  }

  if (
    templateData.showPayments &&
    data.change &&
    customParse(data.change) > 0
  ) {
    printString += `[L]${
      templateData.changeLabel ? templateData.changeLabel : 'Change'
    }`
    printString += `[R]${currencyCode} ${data.change}\n`
  }

  if (
    allowDiscountShow &&
    data.totalSavings &&
    customParse(data.totalSavings) > 0
  ) {
    printString += '[C]*********\n'
    printString += `[L]${
      templateData.totalsavingsLabel
        ? templateData.totalsavingsLabel
        : 'Total Savings'
    }`
    printString += `[R]${currencyCode} ${data.totalSavings}\n`
    // printString += `[C]\n`;
  }

  printString += `[C]*********************************\n`

  if (templateData.showBarCode && data.barcode) {
    printString += `[C]<barcode type='128' width='40' text='above'>${data.barcode}</barcode>\n`
  }
  if (data.saleid || data.indexKey) {
    printString += `[C]<font size='small'>Ref no ${
      data.saleid ? data.saleid : data.indexKey
    }</font>\n`
    if (data.isOffline) {
      printString += `[C]<font size='small'>Offline Sale</font>\n`
      if (data.saleid && data.indexKey) {
        printString += `[C]<font size='small'>${data.indexKey}</font>\n`
      }
    }
  }

  if (
    data &&
    (data.customerEmail ||
      data.customerPhone ||
      data.customerAddress ||
      data.customerGroupName ||
      data.firstName ||
      data.lastName) &&
    templateData.showCustomerDetails
  ) {
    printString += `\n[C]<b>${
      templateData.customersLabel
        ? templateData.customersLabel
        : 'Customer Details'
    }</b>\n`

    if (data.customerGroupName && templateData.showCustomerCompany) {
      printString += `[L]${
        templateData.groupnameLabel ? templateData.groupnameLabel : 'Group Name'
      }`
      printString += `[R]${data.customerGroupName}\n`
    }

    if ((data.firstName || data.lastName) && templateData.showCustomerName) {
      printString += `[L]${
        templateData.cusnameLabel ? templateData.cusnameLabel : 'Customer Name'
      }`
      printString += `[R]${data.firstName + ' ' + data.lastName}\n`
    }

    if (data.customerCode && templateData.showCustomerCode) {
      printString += `[L]Customer Code`
      printString += `[R]${data.customerCode}\n`
    }

    if (data.customerEmail && templateData.showCustomerEmail) {
      printString += `[L]Customer Email`
      printString += `[R]${data.customerEmail}\n`
    }

    if (data.customerPhone && templateData.showCustomerPhone) {
      printString += `[L]Customer Phone`
      printString += `[R]${data.customerPhone}\n`
    }

    if (data.customerAddress && templateData.showCustomerAddress) {
      printString += `[L]Customer Address`
      printString += `[R]${data.customerAddress}\n`
    }

    printString += `[C]--------\n`
  }

  if (templateData.showLoyaltyMessage && templateData.loyaltyMessage) {
    printString += `[C]---------------------------------\n`
    printString += `[C]<font size='small'>${templateData.loyaltyMessage}</font>\n`
  }

  if (templateData.footerHtml && !templateData.footerHtml.includes('null')) {
    printString += `[C]--------\n`
    printString += `${templateData.footerHtml}\n`
  }

  printString += `[C]---------------------------------\n`
  printString += `[C]<font size='small'><b>${PRINT_CONST_FOOTER_1}</b></font>\n`
  printString += `[C]<font size='small'>${PRINT_CONST_FOOTER_2}</font>\n`
  printString += `[C]<font size='small'>${REACT_APP_PRINT_CONST_FOOTER_3}</font>\n\n\n\n`

  console.log('PP_PRINT_', printString)
  return printString
}

export const getZeeFormattedPrint = (
  data,
  today,
  currencyCode,
  decimal,
  showSaleDate,
  showTotalAmount
) => {
  var printString = ''
  if (data) {
    let saleList = ''
    let payList = ''
    data.sales &&
      data.sales.length > 0 &&
      data.totalPayments &&
      data.totalPayments.length > 0 &&
      data.totalPayments.map(qaq => {
        payList += `[L]<b>Total ${qaq.paymentName}`
        payList += `[R]${currencyCode} ${qaq.total}</b>\n`
      })

    data.sales &&
      data.sales.length > 0 &&
      data.sales.map((e, key) => {
        let pays = e.payments
        saleList += `[L]${e.refID ? `${getDecryptID(e.refID)}` : ''}`
        if (showSaleDate) {
          if (pays && pays.length > 0) {
            saleList += `[C]${pays[0].paymentTypeName} `
            saleList += pays[0].amount
              ? `${currencyCode}${pays[0].amount} ${
                  getDecryptID(e.salesOrderStatusID) ===
                  getDecryptID(fetchCurrentSalesOrder('Voided'))
                    ? '(Void)'
                    : ''
                }`
              : ''
          }
          saleList += `[R]${e.date ? moment(e.date).format('l LT') : ''}`
        } else {
          if (pays && pays.length > 0) {
            saleList += `[R]${pays[0].paymentTypeName} `
            saleList += pays[0].amount
              ? `${currencyCode}${pays[0].amount} ${
                  getDecryptID(e.salesOrderStatusID) ===
                  getDecryptID(fetchCurrentSalesOrder('Voided'))
                    ? '(Void)'
                    : ''
                }`
              : ''
          }
        }
        saleList += '\n'

        if (pays && pays.length > 1) {
          pays.map((q, w) => {
            if (w > 0) {
              let payper = `${showSaleDate ? '[C]' : '[R]'}`
              payper += `${q.paymentTypeName} `
              payper += q.amount
                ? `${currencyCode} ${q.amount} ${
                    getDecryptID(e.salesOrderStatusID) ===
                    getDecryptID(fetchCurrentSalesOrder('Voided'))
                      ? '(Void)'
                      : ''
                  }`
                : ''
              payper += '\n'

              if (w + 1 == pays.length) {
                payper += `${showSaleDate ? '[C]TOTAL ' : '[R]TOTAL '}`
                payper += e.amountList ? `${currencyCode} ${e.amountList}` : ''
                payper += '\n'
              }

              saleList += payper
            }
          })
        }
      })

    if (data.storeName) {
      printString += `[C]<b>${data.storeName}</b>\n`
    }
    if (data.outletName) {
      printString += `[C]<b>${data.outletName}</b>\n`
    }
    if (data.registerName) {
      printString += `[C]<b>${data.registerName}</b>\n`
    }
    if (today) {
      printString += `[C]${today}\n`
    }
    if (data.storeName) {
      printString += `[C]<b>${data.storeName}</b>\n`
    }
    printString += `[C]--------------------------\n`

    if (showSaleDate) {
      printString += `[L][C]Amount[R]Date\n`
    } else {
      printString += `[L][C][R]Amount\n`
    }

    if (saleList) {
      printString += `${saleList}`
    }
    if (payList) {
      printString += `[C]--------------------------\n`
      printString += `${payList}`
    }

    if (showTotalAmount && data.sales && data.sales.length > 0) {
      printString += `[C]--------------------------\n`
      printString += `[L]<b>Total Amount:[R]${currencyCode} ${data.totalAmountPayList}</b>\n`
    }

    if (data.totalVoid) {
      printString += `[L]<b>Total Void:[R]${currencyCode} ${data.totalVoid}</b>\n`
    }
    printString += `[C]---------------------------------\n`
    printString += `[C]<font size='small'><b>${PRINT_CONST_FOOTER_1}</b></font>\n`
    printString += `[C]<font size='small'>${PRINT_CONST_FOOTER_2}</font>\n`
    printString += `[C]<font size='small'>${REACT_APP_PRINT_CONST_FOOTER_3}</font>\n\n\n\n`
  }

  console.log('PP_PRINT_', printString)
  return printString
}

export const getOpenCloseFormattedPrint = (
  data,
  today,
  currencyCode,
  decimal,
  storeInfo
) => {
  var printString = ''
  if (data) {
    if (storeInfo && storeInfo.storeName) {
      printString += `[C]<b>${data.storeName}</b>\n`
    }
    if (today) {
      printString += `[C]${today}\n`
    }
    printString += `[C]--------------------------\n`

    if (data.type) {
      printString += `[C]<b>${
        data.type == PRINT_TYPES.opening
          ? 'Opening Float'
          : data.type == PRINT_TYPES.cashMove
          ? `${
              data.cashType == PRINT_CASH_MOVE_TYPES.CASH_IN
                ? 'CASH IN'
                : data.cashType == PRINT_CASH_MOVE_TYPES.CASH_OUT
                ? 'CASH OUT'
                : data.cashType == PRINT_CASH_MOVE_TYPES.PETTY_CASH_IN
                ? 'PETTY CASH IN'
                : data.cashType == PRINT_CASH_MOVE_TYPES.PETTY_CASH_OUT
                ? 'PETTY CASH OUT'
                : ''
            }`
          : ''
      }</b>\n`
    }

    if (data.amount) {
      printString += `[C]${currencyCode} ${formatDigits(
        data.amount,
        decimal
      )}\n`
      printString += `[C]--------------------------\n`
    }
    if (data.outlet) {
      printString += `[L]Outlet[R]${data.outlet}\n`
    }
    if (data.register) {
      printString += `[L]Register[R]${data.register}\n`
    }
    if (data.date) {
      printString += `[L]Date[R]${moment(data.date).format('l LT')}\n`
    }
    if (data.user) {
      printString += `[L]User[R]${data.user}\n`
    }
    if (data.note) {
      printString += `[L]Note[R]${data.note}\n`
    }
    printString += `[C]---------------------------------\n`
    printString += `[C]<font size='small'><b>${PRINT_CONST_FOOTER_1}</b></font>\n`
    printString += `[C]<font size='small'>${PRINT_CONST_FOOTER_2}</font>\n`
    printString += `[C]<font size='small'>${REACT_APP_PRINT_CONST_FOOTER_3}</font>\n\n\n\n`
  }

  console.log('PP_PRINT_', printString)
  return printString
}

export const getIOSSalesFormattedPrint = (
  templateData,
  data,
  today,
  currencyCode,
  decimal,
  allowPrintNote,
  allowDiscountShow
) => {
  var printString = ''
  let sellAttribs = ''
  data.sellSelData &&
    data.sellSelData.length > 0 &&
    data.sellSelData.map((as, io) => {
      sellAttribs += `${
        as.groupName || as.attributeName
          ? `${as.groupName} ${as.attributeName ? as.attributeName : ''}`
          : ''
      }\n`
      // return `${as.groupName || as.attributeName ? `[C]${as.groupName} ${as.attributeName ? as.attributeName : ''}`: ''}\n`
    })

  const result = {
    head: {
      headInfo: [],
      logo: '',
      outlet: '',
      register: '',
      soldBy: '', // Served By: (name in bold)
      isReprint: false,
      receipt: '', // underline + bold
      date: '',
      saleNature: '',
      isRefund: false,
      sellAttribs: ''
    },
    products: [],
    saleInfo: {
      notes: '',
      subTotal: '',
      additionalDiscount: '',
      totalTax: '',
      taxesSum: [],
      totalPrice: '',
      payments: [],
      toPay: '',
      loyalty: '',
      change: '',
      totalSavings: ''
    },
    footer: {
      barcode: '',
      refNo: '',
      isOffline: false,
      indexKey: '',
      customer: {
        customerEmail: '',
        customerPhone: '',
        customerAddress: '',
        customerGroupName: '',
        firstName: '',
        lastName: '',
        customerCode: ''
      },
      loyaltyMessage: '',
      footerHtml: [],
      footer_msg_1: PRINT_CONST_FOOTER_1,
      footer_msg_2: PRINT_CONST_FOOTER_2,
      footer_msg_3: REACT_APP_PRINT_CONST_FOOTER_3
    }
  }

  // // PRODUCT START

  data.products &&
    data.products.length > 0 &&
    data.products.map((e, key) => {
      let prod = {
        name: '', // bold
        quantity: '',
        total_price: '',
        single_price: '',
        helper: '',
        promo: '',
        pb: '',
        note: '',
        taxCode: ''
      }
      if (templateData.showSKU) {
        prod.name = e.SKU
      }
      if (templateData.showProductName) {
        prod.name = ` ${e.productName}`
      }
      if (templateData.showProductNameAndSKU) {
        prod.name = `${e.productName} / SKU: ${e.SKU}`
      }

      prod.quantity = `${e.quantity ? `${parseIntCustom(e.quantity)}` : ''}`
      if (templateData.showProdPrice && e.totalPriceReceipt) {
        prod.total_price = formatCurrAmount(
          `${currencyCode}`,
          `${e.totalPriceReceipt}`,
          e.taxCode ? 10 : 8,
          `${e.taxCode}`
        )
        // prod.total_price = `${currencyCode} ${e.totalPriceReceipt} ${
        //   e.taxCode ? e.taxCode : ''
        // }`
        prod.single_price = `${currencyCode} ${formatDigits(
          parseFloatCustom(e.totalPriceReceipt) / parseFloatCustom(e.quantity),
          decimal
        )}`
      }

      if (templateData.showProdPrice && allowDiscountShow) {
        if (e.salesItemDiscount && customParse(e.salesItemDiscount) > 0) {
          prod.helper = `Was: ${currencyCode} ${formatDigits(
            customParse(e.totalPriceReceipt / e.quantity) +
              customParse(e.salesItemDiscount),
            decimal
          )} Disc: ${e.discountPercentage}% / ${currencyCode} ${formatDigits(
            e.salesItemDiscount,
            decimal
          )}`
        }

        if (
          e.promotions &&
          !isEmptyObject(e.promotions) &&
          e.promotions.promotionName &&
          e.promotions.promotionName != ''
        ) {
          prod.promo = `Promotion: ${e.promotions.promotionName} (${
            e.promotionPercent ? `${e.promotionPercent}% / ` : ''
          } ${currencyCode} ${
            e.promotions.promotionValue
              ? formatDigits(e.promotions.promotionValue / e.quantity, decimal)
              : '0.00'
          } off)`
        }

        if (e.priceBookValue && customParse(e.priceBookValue) > 0) {
          prod.pb = `Disc: (${
            e.priceBookPercent ? `${e.priceBookPercent}%  / ` : ''
          } ${currencyCode} ${formatDigits(
            e.priceBookValue / e.quantity,
            decimal
          )} off)`
        }
      }

      if (allowPrintNote && e.productNote && e.productNote != '') {
        prod.note = `ITEM NOTE: ${e.productNote}`
      }

      result.products.push(prod)
    })

  // // PRODUCT END

  // // HEAD START

  if (templateData.headImageURL) {
    result.head.logo = `${templateData.headImageURL}`
  }

  if (
    templateData.headInfoPlain &&
    !templateData.headInfoPlain.includes('null')
  ) {
    const da = templateData.headInfoPlain.split('/n')
    if (da && da.length > 0) {
      da.map(a => {
        let r = a.replaceAll('\n', '')
        r = r.replaceAll('\r', '')
        result.head.headInfo.push({
          value: r,
          isBold: true
        })
      })
    }
  }
  if (templateData.showOutlet && data.outletName) {
    result.head.outlet = `${data.outletName}`
  }
  if (templateData.showRegister && data.mainRegister) {
    result.head.register = `${data.mainRegister}`
  }
  if (templateData.isDisplayServedBy && data.soldBy) {
    result.head.soldBy = `${data.soldBy}`
  }
  if (data.isRepeat) {
    result.head.isReprint = true
  }

  if (data.receipt) {
    result.head.receipt = `${
      templateData.invoiceNoPrefix
        ? `${templateData.invoiceNoPrefix} `
        : 'Receipt '
    }${data.receipt}`
  }
  if (templateData.showDatetime) {
    result.head.date = `${today}`
  }
  if (data.saleNature && data.saleNature != '') {
    result.head.saleNature = `${data.saleNature}`
  }
  if (data.isRefundSale) {
    result.head.isRefund = true
  }
  if (sellAttribs) {
    result.head.sellAttribs = sellAttribs
  }

  // // HEAD END

  if (allowPrintNote && data && data.Notes) {
    result.saleInfo.notes = `${data.Notes}`
  }

  if (templateData.showSubTotal && data.totalPrice) {
    result.saleInfo.subTotal = formatCurrAmount(
      `${currencyCode}`,
      `${formatDigits(
        customParse(data.totalPrice) +
          (data.additionalDiscount && data.additionalDiscount != '0.00'
            ? customParse(data.additionalDiscount)
            : 0) -
          customParse(data.totalTax),
        decimal
      )}`,
      9,
      false
    )
    // result.saleInfo.subTotal = `${currencyCode} ${formatDigits(
    //   customParse(data.totalPrice) +
    //     (data.additionalDiscount && data.additionalDiscount != '0.00'
    //       ? customParse(data.additionalDiscount)
    //       : 0) -
    //     customParse(data.totalTax),
    //   decimal
    // )}`
  }

  if (
    (templateData.showTotal || templateData.showSubTotal) &&
    data.additionalDiscount &&
    data.additionalDiscount != ''
  ) {
    result.saleInfo.additionalDiscount = formatCurrAmount(
      `${currencyCode}`,
      `${
        data.additionalDiscount && data.additionalDiscount.includes('-')
          ? data.additionalDiscount.replace('-', '')
          : data.additionalDiscount
      }`,
      9,
      false
    )
    // result.saleInfo.additionalDiscount = `${currencyCode} ${
    //   data.additionalDiscount && data.additionalDiscount.includes('-')
    //     ? data.additionalDiscount.replace('-', '')
    //     : data.additionalDiscount
    // }`
  }

  if (templateData.showTaxTotals && data.totalTax) {
    result.saleInfo.totalTax = formatCurrAmount(
      `${currencyCode}`,
      `${data.totalTax}`,
      9,
      false
    )
    // result.saleInfo.totalTax = `${currencyCode} ${data.totalTax}`
  }

  if (templateData.showTaxTotals && data.taxesSum && data.taxesSum.length > 0) {
    data.taxesSum.map((e, key) => {
      let obj = {
        taxMsg: '',
        taxPrice: ''
      }
      obj.taxMsg = `${
        e.saleTaxName
          ? `${e.saleTaxName} ${e.taxCode ? e.taxCode : ''}   (${
              e.isFix ? e.fixRate : e.taxValue
            } ${e.isFix ? ' FIX' : '%'})`
          : ''
      }`

      if (
        (getDecryptID(data.sSalesOrderStatusID) ==
          getDecryptID(fetchCurrentSalesOrder('On Account, completed')) ||
          getDecryptID(data.sSalesOrderStatusID) ==
            getDecryptID(fetchCurrentSalesOrder('Layby, completed'))) &&
        data.salesOrderDiscountPrice &&
        data.salesOrderDiscountPrice != '0.00'
      ) {
      } else {
        if (
          data.isRefundSale &&
          data.additionalDiscount &&
          data.additionalDiscount != ''
        ) {
        } else {
          obj.taxPrice = `${e.taxPrice ? `${currencyCode} ${e.taxPrice}` : ''}`
        }
      }

      result.saleInfo.taxesSum.push(obj)
    })
  }

  if (templateData.showTotal && data.totalPrice) {
    result.saleInfo.totalPrice = formatCurrAmount(
      `${currencyCode}`,
      `${data.totalPrice}`,
      9,
      false
    )
    // result.saleInfo.totalPrice = `${currencyCode} ${data.totalPrice}`
  }

  if (templateData.showPayments && data.payments && data.payments.length > 0) {
    data.payments.map((pay, key) => {
      if (pay.amount != '0.00') {
        let obj = {
          pay_name: '',
          pay_on: '',
          pay_amount: ''
        }

        obj.pay_name = `${
          pay.paymentName ? pay.paymentName : `Payment ${key + 1}`
        }`
        obj.pay_on = pay.paymentOn ? `${pay.paymentOn}` : ''
        obj.pay_amount = pay.amount ? `${currencyCode} ${pay.amount}` : ''

        result.saleInfo.payments.push(obj)
      }
    })
  }

  if (templateData.showPayments && data.toPay && data.toPay != '') {
    result.saleInfo.toPay = `${currencyCode} ${data.toPay}`
  }

  if (
    templateData.showLoyaltyEarned &&
    data.totalLoyaltyValue &&
    data.totalLoyaltyValue > 0
  ) {
    result.saleInfo.loyalty = `${currencyCode} ${formatDigits(
      data.totalLoyaltyValue,
      decimal
    )}`
  }

  if (
    templateData.showPayments &&
    data.change &&
    customParse(data.change) > 0
  ) {
    result.saleInfo.change = `${currencyCode} ${data.change}`
  }

  if (
    allowDiscountShow &&
    data.totalSavings &&
    customParse(data.totalSavings) > 0
  ) {
    result.saleInfo.totalSavings = `${currencyCode} ${data.totalSavings}`
  }

  if (templateData.showBarCode && data.barcode) {
    result.footer.barcode = `${data.barcode}`
  }
  if (data.saleid || data.indexKey) {
    result.footer.refNo = `Ref no ${data.saleid ? data.saleid : data.indexKey}`
    if (data.isOffline) {
      result.footer.isOffline = true
      if (data.saleid && data.indexKey) {
        result.footer.indexKey = `${data.indexKey}`
      }
    }
  }

  if (
    data &&
    (data.customerEmail ||
      data.customerPhone ||
      data.customerAddress ||
      data.customerGroupName ||
      data.firstName ||
      data.lastName) &&
    templateData.showCustomerDetails
  ) {
    if (data.customerGroupName && templateData.showCustomerCompany) {
      result.footer.customer.customerGroupName = `${data.customerGroupName}`
    }

    if ((data.firstName || data.lastName) && templateData.showCustomerName) {
      result.footer.customer.firstName = `${data.firstName}`
      result.footer.customer.lastName = `${data.lastName}`
    }

    if (data.customerCode && templateData.showCustomerCode) {
      result.footer.customer.customerCode = `${data.customerCode}`
    }

    if (data.customerEmail && templateData.showCustomerEmail) {
      result.footer.customer.customerEmail = `${data.customerEmail}`
    }

    if (data.customerPhone && templateData.showCustomerPhone) {
      result.footer.customer.customerPhone = `${data.customerPhone}`
    }

    if (data.customerAddress && templateData.showCustomerAddress) {
      result.footer.customer.customerAddress = `${data.customerAddress}`
    }
  }

  if (
    !data.customerEmail &&
    templateData.showLoyaltyMessage &&
    templateData.loyaltyMessage
  ) {
    result.footer.loyaltyMessage = `${templateData.loyaltyMessage}`
  }

  if (templateData.footerPlain && !templateData.footerPlain.includes('null')) {
    const da = templateData.footerPlain.split('/n')
    if (da && da.length > 0) {
      da.map(a => {
        let r = a.replaceAll('\n', '')
        r = r.replaceAll('\r', '')
        result.footer.footerHtml.push({
          value: r,
          isBold: true
        })
      })
    }
  }

  result.footer.footer_msg_1 = `${PRINT_CONST_FOOTER_1}`
  result.footer.footer_msg_2 = `${PRINT_CONST_FOOTER_2}`
  result.footer.footer_msg_3 = `${REACT_APP_PRINT_CONST_FOOTER_3}`

  console.log('PP_PRINT_', JSON.stringify(result))
  return result
}

export const getIOSZeeFormattedPrint = (
  data,
  today,
  currencyCode,
  decimal,
  showSaleDate,
  showTotalAmount
) => {
  var printString = ''

  const result = {
    storeName: '',
    outletName: '',
    registerName: '',
    date: '',
    totalAmount: '',
    totalVoid: '',
    footer_1: '',
    footer_2: '',
    footer_3: '',
    saleList: [],
    payList: []
  }

  if (data) {
    let saleList = ''
    let payList = ''
    data.sales &&
      data.sales.length > 0 &&
      data.totalPayments &&
      data.totalPayments.length > 0 &&
      data.totalPayments.map(qaq => {
        result.payList.push({
          name: `Total ${qaq.paymentName}`,
          amount: `${currencyCode}${qaq.total}`
        })
      })

    data.sales &&
      data.sales.length > 0 &&
      data.sales.map((e, key) => {
        const obj = {
          refID: '',
          amount: [],
          date: '' // date aarhe hai to amount center date right agar nahe aarhe to amount right
        }
        let pays = e.payments
        obj.refID = `${e.refID ? `${getDecryptID(e.refID)}` : ''}`
        if (showSaleDate) {
          if (pays && pays.length > 0) {
            obj.amount.push(
              `${pays[0].paymentTypeName} ${
                pays[0].amount
                  ? `${currencyCode}${pays[0].amount}${
                      getDecryptID(e.salesOrderStatusID) ===
                      getDecryptID(fetchCurrentSalesOrder('Voided'))
                        ? ' (Void)'
                        : ''
                    }`
                  : ''
              }`
            )
          }
          obj.date = `${e.date ? moment(e.date).format('l LT') : ''}`
        } else {
          if (pays && pays.length > 0) {
            obj.amount.push(
              `${pays[0].paymentTypeName} ${
                pays[0].amount
                  ? `${currencyCode}${pays[0].amount}${
                      getDecryptID(e.salesOrderStatusID) ===
                      getDecryptID(fetchCurrentSalesOrder('Voided'))
                        ? ' (Void)'
                        : ''
                    }`
                  : ''
              }`
            )
          }
        }

        if (pays && pays.length > 1) {
          pays.map((q, w) => {
            if (w > 0) {
              let payper = `${q.paymentTypeName} `
              payper += q.amount
                ? `${currencyCode}${q.amount}${
                    getDecryptID(e.salesOrderStatusID) ===
                    getDecryptID(fetchCurrentSalesOrder('Voided'))
                      ? ' (Void)'
                      : ''
                  }`
                : ''
              obj.amount.push(payper)

              if (w + 1 == pays.length) {
                obj.amount.push(
                  `TOTAL ${
                    e.amountList ? `${currencyCode}${e.amountList}` : ''
                  }`
                )
              }
            }
          })
        }

        result.saleList.push(obj)
      })

    if (data.storeName) {
      result.storeName = `${data.storeName}`
    }
    if (data.outletName) {
      result.outletName = `${data.outletName}`
    }
    if (data.registerName) {
      result.registerName = `${data.registerName}`
    }
    if (today) {
      result.date = `${today}`
    }

    if (showTotalAmount && data.sales && data.sales.length > 0) {
      result.totalAmount = `${currencyCode}${data.totalAmountPayList}`
    }

    if (data.totalVoid) {
      result.totalVoid = `${currencyCode}${data.totalVoid}`
    }
    result.footer_1 = `${PRINT_CONST_FOOTER_1}`
    result.footer_2 = `${PRINT_CONST_FOOTER_2}`
    result.footer_3 = `${REACT_APP_PRINT_CONST_FOOTER_3}`
  }

  console.log('PP_PRINT_', JSON.stringify(result))
  return result
}

export const getIOSOpenCloseFormattedPrint = (
  data,
  today,
  currencyCode,
  decimal,
  storeInfo
) => {
  var printString = ''
  const result = {
    storeName: '',
    today: '',
    type: '',
    amount: '',
    outlet: '',
    register: '',
    date: '',
    user: '',
    note: '',
    footer_1: '',
    footer_2: '',
    footer_3: ''
  }
  if (data) {
    if (storeInfo && storeInfo.storeName) {
      result.storeName = `${data.storeName}`
    }
    if (today) {
      result.today = `${today}`
    }

    if (data.type) {
      result.type += `${
        data.type == PRINT_TYPES.opening
          ? 'Opening Float'
          : data.type == PRINT_TYPES.cashMove
          ? `${
              data.cashType == PRINT_CASH_MOVE_TYPES.CASH_IN
                ? 'CASH IN'
                : data.cashType == PRINT_CASH_MOVE_TYPES.CASH_OUT
                ? 'CASH OUT'
                : data.cashType == PRINT_CASH_MOVE_TYPES.PETTY_CASH_IN
                ? 'PETTY CASH IN'
                : data.cashType == PRINT_CASH_MOVE_TYPES.PETTY_CASH_OUT
                ? 'PETTY CASH OUT'
                : ''
            }`
          : ''
      }`
    }

    if (data.amount) {
      result.amount = `${currencyCode} ${formatDigits(data.amount, decimal)}`
    } else {
      result.amount = `${currencyCode} 0.00`
    }
    if (data.outlet) {
      result.outlet = `${data.outlet}`
    }
    if (data.register) {
      result.register = `${data.register}`
    }
    if (data.date) {
      result.date = `${moment(data.date).format('l LT')}`
    }
    if (data.user) {
      result.user = `${data.user}`
    }
    if (data.note) {
      result.note = `${data.note}`
    }
    result.footer_1 = `${PRINT_CONST_FOOTER_1}`
    result.footer_2 = `${PRINT_CONST_FOOTER_2}`
    result.footer_3 = `${REACT_APP_PRINT_CONST_FOOTER_3}`
  }

  console.log('PP_PRINT_', JSON.stringify(result))
  return result
}
